import { useEffect, useMemo } from 'react';
import { GoogleOutlined } from '@ant-design/icons';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import config from '@/config';
import { Button, Heading, Link, Text } from '@/modules/ui';

import * as felaRules from './ExistingInstallationPage.rules';

export const ExistingInstallationPage = () => {
    const { css } = useFela();
    const { state } = useLocation();
    const navigate = useNavigate();

    const appUrl = useMemo(() => {
        if (typeof state?.appUrl === 'string') {
            return new URL(state.appUrl.startsWith('http') ? state.appUrl : `https://${state.appUrl}`);
        }

        return null;
    }, [state]);

    useEffect(() => {
        if (!appUrl) {
            navigate(config.routes.home, { replace: true });
        }
    }, [appUrl, navigate]);

    if (!appUrl) {
        return null;
    }

    const signInUrl = new URL(config.googleOAuth.signInRedirectUrl, appUrl);

    return (
        <main className={css(felaRules.container)}>
            <section className={css(felaRules.card)}>
                <Heading variant='h2' elementType='h1' color='foregroundsPrimary'>
                    <FormattedMessage
                        id='auth.existingInstallation.title'
                        values={{ appUrl: <strong className={css(felaRules.appUrl)}>{appUrl.hostname}</strong> }}
                    />
                </Heading>

                <Text color='foregroundsTertiary' preserveNewLines customStyle={felaRules.description}>
                    <FormattedMessage
                        id='auth.existingInstallation.description'
                        values={{
                            appUrl: (
                                <Link type='native' href={appUrl.toString()} noreferrer className={css(felaRules.appUrl)}>
                                    {appUrl.hostname}
                                </Link>
                            ),
                        }}
                    />
                </Text>

                <Button
                    type='primary'
                    size='large'
                    icon={<GoogleOutlined />}
                    href={signInUrl.toString()}
                    target='_self'
                    rel='noopener noreferrer'
                    customStyle={felaRules.loginButton}
                >
                    <FormattedMessage id='auth.existingInstallation.loginButton' values={{ appUrl: appUrl.hostname }} />
                </Button>
            </section>
        </main>
    );
};
